import { render, staticRenderFns } from "./BundleCourseDetail.vue?vue&type=template&id=67bb97a8&scoped=true"
import script from "./BundleCourseDetail.vue?vue&type=script&lang=ts"
export * from "./BundleCourseDetail.vue?vue&type=script&lang=ts"
import style0 from "./BundleCourseDetail.vue?vue&type=style&index=0&id=67bb97a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb97a8",
  null
  
)

export default component.exports